.bam-text-and-image__image-container {
  @media screen and (max-width: 767px) {
    padding-bottom: 0 !important;
  }
}

